import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToastMessageComponent } from '../common/toast-message/toast-message.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthService } from './auth.service';
import { UserService } from './../home/services/user.service';
import { SharedModule } from '../shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-login',
  imports: [ToastMessageComponent, FormsModule, CommonModule, NgxSpinnerModule, SharedModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;

  public userId: any;
  public errorMsg: string = "";
  public fadeOutAlert = true;

  constructor(public route: Router, private currentRoute: ActivatedRoute, public authService: AuthService, public userservice: UserService) { }

  showPassword = signal(false);

  ngOnInit() {
    // this.fadeOut();
  }

  login(data) {
    const dataObj = {
      username: data.username,
      password: data.password,
      device: "web"
    };

    this.authService.login(dataObj).subscribe({
      next: (res) => {
        if (res.data) {
          this.errorMsg = "";
          // Store user details in local storage
          this.userservice.setToken(res.data.token, res.data.roles[0]);
          localStorage.setItem('userId', res.data.user_id);
          localStorage.setItem('username', res.data.username);
          // localStorage.setItem('role', res.data.roles[0]);
          // localStorage.setItem('token', res.data.token);

          // Store default store ID in localStorage if available
          if (res.data.default_store_id) {
            localStorage.setItem('defaultStoreId', res.data.default_store_id.toString());
          }

          this.currentRoute.queryParams.subscribe(params => {
            if (params.redirect_link) {
              this.route.navigate([params.redirect_link]);
            } else {
              this.route.navigate(['/home/dashboard-v2']);
            }
          });
        }
      },
      error: (err) => {
        console.log('err', err);
        if (err.status === 401) {
          this.errorMsg = err.error.message;
        } else if (err.status === 403) {
          this.errorMsg = "";
          this.toastMessage.showToast("Looks like you don't have access to the web app. Please contact the admin for access.", "error", 5000);
        } else {
          this.errorMsg = "";
          this.toastMessage.showToast("something went wrong! please try again later", "error", 5000);
        }
      },
      complete: () => {
        console.log('completed');
      }
    });
  }
}
